/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesGroupSubgroupFailureSpec } from './capabilitiesGroupSubgroupFailureSpec';
import { CapabilitiesGroupSubgroupSpec } from './capabilitiesGroupSubgroupSpec';
import { CapabilitiesSpec } from './capabilitiesSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OrgCapabilitiesResponseSpec { 
    service_type?: ServiceTypeEnum;
    capabilities?: CapabilitiesSpec;
    success?: Array<CapabilitiesGroupSubgroupSpec>;
    failed?: Array<CapabilitiesGroupSubgroupFailureSpec>;
}
export namespace OrgCapabilitiesResponseSpec {
}


